import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { GetCredits400Response } from '../models/GetCredits400Response';
import { GetCreditsResponse } from '../models/GetCreditsResponse';

/**
 * no description
 */
export class GetCreditsApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Get current credits
   */
  public async getCredits(_options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // Path Params
    const localVarPath = '/v1/credits';

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.GET, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class GetCreditsApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to getCredits
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async getCreditsWithHttpInfo(response: ResponseContext): Promise<HttpInfo<GetCreditsResponse >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: GetCreditsResponse = ObjectSerializer.deserialize(
        await response.body.json(),
        "GetCreditsResponse", ""
      ) as GetCreditsResponse;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("400", response.httpStatusCode)) {
      const body: GetCredits400Response = ObjectSerializer.deserialize(
        await response.body.json(),
        "GetCredits400Response", ""
      ) as GetCredits400Response;
      throw new ApiException<GetCredits400Response>(response.httpStatusCode, "Bad request - Invalid parameters", body, response.headers, response);
    }
    if (isCodeInRange("401", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Unauthorized - Invalid authentication", undefined, response.headers, response);
    }
    if (isCodeInRange("403", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Forbidden - Insufficient permissions", undefined, response.headers, response);
    }
    if (isCodeInRange("500", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Internal server error - Unexpected issue occurred", undefined, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: GetCreditsResponse = await response.body.json() as GetCreditsResponse;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
